module.exports = __webpack_public_path__ + "img/3@2x.c8fe405d.png";